import React, { useEffect, useState } from 'react';
import VerificationPopup from '../modals/VerificationPopup';
import styles from '../../styles/newFeature.module.css';
import content from '../../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton } from '../qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from '../Industry/FAQ_mobile';
import FrequentQuestions from '../homePage/FrequentQuestions';
import MobilePDBanner from '../common/MobilePDBanner';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import MobileTestimonialSection from '../common/MobileTestimonialSection';
import ThreeStepForm from '../common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from '../common/OutletFeatures';
import { useRouter } from 'next/router';

const AutomobileBillingSoftware = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/AutomobileBillingSoftware/pointOfSale.webp",
            tag: "Point Of Sale",
            icon: "/assets/groceries/kirana/POS.svg",
            title: "Point of Sale Billing",
            desc: "QueueBuster POS delivers high-efficiency billing with options to create GST-compliant invoices, making operations smooth and error-free. This feature is especially helpful for retailers who need eWay billing and eInvoicing to ensure accurate documentation for goods movement.",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Generate invoices in under 3 seconds with Quick Bill, streamlining your billing process.
                </>,
                <>
                    Choose from multiple payment options, including cash, credit card, UPI, wallet, and coupon codes.
                </>,
                <>
                   Enjoy a variety of invoice formats tailored to meet business requirements.
                </>,
            ],
        },
        {
            id: 2,
            image: "/assets/AutomobileBillingSoftware/inventory.webp",
            tag: "Inventory Management",
            icon: "/assets/outlet/iceCreamOutlet/inventoryManagementIcon.svg",
            title: "Inventory Management",
            desc: "Managing inventory is crucial for profitability and customer satisfaction. QueueBuster simplifies stock tracking, helping businesses keep a close watch on stock levels and project future sales and profits.",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>
                   Track inventory in real-time from any Android device, ensuring accurate stock visibility.
                </>,
                <>
                   Create inventory entries effortlessly and stay organized with barcode generation.
                </>,
                <>
                    Get alerts on low stock to proactively manage inventory and meet demand.
                </>,
            ],
        },
        {
            id: 3,
            image: "/assets/AutomobileBillingSoftware/vendor.webp",
            tag: "Vendor Management",
            icon: "/assets/outlet/iceCreamOutlet/vendorIcon.svg",
            title: "Purchase and Sales Order",
            desc: "QueueBuster POS makes purchase and sales orders easy to handle, enabling better control over stock levels and vendor management. Retailers can monitor stock movement, track vendor information, and set reorder thresholds for operational efficiency.",
            tagColor: "#EEC9FF",
            bgColor: "#fcf6ff",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "10rem",
            eHeight: "29rem",
            msHeight: "17rem",
            meHeight: "45rem",
            btnText: "Talk	to an expert",
            points: [
                <>
                   Place and manage purchase orders directly through the POS system.
                </>,
                <>
                    Set automated reorder levels to ensure you're never out of essential items.
                </>,
                <>
                    Store vendor information and order history for easy reference and efficient reordering.
                </>,
            ],
        },
        {
            id: 4,
            image: "/assets/AutomobileBillingSoftware/onlineStore.webp",
            tag: "Online Stores",
            icon: "/assets/outlet/iceCreamOutlet/estoreIcon.svg",
            title: "Drive more foot traffic with customized discounts. loyalty rewards and promotions.",
            desc: "Drive more footfall with customized discounts, loyalty rewards, and promotions. QueueBuster lets you effortlessly create, manage, and track discount campaigns, which can attract new customers and retain existing ones.",
            tagColor: "#4EEAC2",
            bgColor: "#e6fff9",
            stackColor1: "#C8F4E9",
            stackColor2: "#9EE9D6",
            stackColor3: "#4EEAC2",
            stackColor4: "#47DDB6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Set up custom discount codes for specific customer groups or seasonal sales.
                </>,
                <>
                    Monitor promotion success and adjust offers to maximize impact.
                </>,
                <>
                    Implement automatic loyalty discounts for repeat customers and frequent buyers.
                </>,
            ],
        },
        
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                     How can QueueBuster POS benefit my automobile retail business?
               </span>
            ),
            des: "QueueBuster POS optimizes billing, inventory, and customer management processes, reducing manual work, improving data accuracy, and helping you serve customers faster and more efficiently.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                  Does QueueBuster support GST-compliant invoicing?
                </span>
            ),
            des: "Yes, QueueBuster supports GST invoicing along with e-invoicing and eWay billing, making it easier to stay compliant with government regulations and ensure smooth movement of goods.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   Can I use QueueBuster for multiple payment types?
                </span>
            ),
            des: "Absolutely. QueueBuster POS accommodates diverse payment options, including cash, credit cards, UPI, and digital wallets, providing convenience for both retailers and customers.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                     Is it possible to manage inventory across multiple stores?
                </span>
            ),
            des: "Yes, QueueBuster enables centralized inventory management across multiple locations, ensuring a clear view of stock levels and easy access to data from any store.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster help with customer loyalty programs?
                </span>
            ),
            des: "QueueBuster integrates CRM and loyalty program features, allowing you to build and maintain relationships with customers by offering rewards and personalized promotions that encourage repeat business.",
            id: 5,
            activeIndex: 0,
        },
       
       
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/AutomobileBillingSoftware/mobilehero-automobile.webp')" }}>
                        <div>
                            <h1>
                                <span>POS Billing Software <br />for</span><span></span>
                                <span>&nbsp; Automobile Shops</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>QueueBuster POS Billing Software is designed specifically for automobile retail shops, including service centers, bike accessories, and car accessories stores. With robust features for managing billing, inventory, khata, CRM & loyalty, and eStore, it ensures seamless operations and a great customer experience.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 5rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/AutomobileBillingSoftware/hero-automobile.webp"
                            heading={<>POS Billing  <br />Software for <br /></>}
                            staticHeading={<> Automobile Shops</>}
                            description={"QueueBuster POS Billing Software is designed specifically for automobile retail shops, including service centers, bike accessories, and car accessories stores. With robust features for managing billing, inventory, khata, CRM & loyalty, and eStore, it ensures seamless operations and a great customer experience."}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "63%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>Top Features Tailored for Car & Bike Accessories Outlets</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"FAQs for QueueBuster Automobile Billing Software"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"FAQs for QueueBuster Automobile Billing Software"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default AutomobileBillingSoftware
 
 